import { page } from '$app/state';
import { PersistedState } from 'runed';
import type { GameType } from '~/types';

export const CLASSIC_VERSION = 7;
export const DAILY_VERSION = 9;
export const CHANGELOG_VERSION = 17;

export const classicVersion = new PersistedState('classicVersion', 0);
export const dailyVersion = new PersistedState('dailyVersion', 0);
export const dailyOnboarded = new PersistedState('daily.onboarded', false);
export const classicOnboarded = new PersistedState('classic.onboarded', false);
export const changelogVersion = new PersistedState('changelogVersion', 0);

class Onboarded {
  get gameMode(): GameType {
    return (
      (page.params.mode as GameType) ??
      (page.route.id?.slice(1) as GameType) ??
      'daily'
    );
  }

  get current() {
    switch (this.gameMode) {
      case 'mini':
      case 'daily':
        return dailyOnboarded.current;
      case 'classic':
        return classicOnboarded.current;
      default:
        return true;
    }
  }

  set current(val: boolean) {
    switch (this.gameMode) {
      case 'mini':
      case 'daily':
        dailyOnboarded.current = val;
        break;
      case 'classic':
        classicOnboarded.current = val;
        break;
      default:
        //
    }
  }
}

export const onboarded = new Onboarded();

// PersistedState can't read localStorage during SSR, so server-rendered pages
// see onboarded as false and flash the tutorial until hydration. Gate on this
// (set once by the root layout after mount) to render a splash instead.
export const hydrated = $state({ current: false });

class TutorialViewed {
  get gameMode(): GameType {
    return (
      (page.params.mode as GameType) ??
      (page.route.id?.slice(1) as GameType) ??
      'daily'
    );
  }

  get current() {
    switch (this.gameMode) {
      case 'mini':
      case 'daily':
        return dailyVersion.current === DAILY_VERSION;
      case 'classic':
        return classicVersion.current === CLASSIC_VERSION;
      default:
        return true;
    }
  }

  set current(val: boolean) {
    switch (this.gameMode) {
      case 'mini':
      case 'daily':
        dailyVersion.current = val ? DAILY_VERSION : 0;
        break;
      case 'classic':
        classicVersion.current = val ? CLASSIC_VERSION : 0;
        break;
      default:
        //
    }
  }
}

export const tutorialViewed = new TutorialViewed();

class ChangelogViewed {
  get current() {
    return changelogVersion.current === CHANGELOG_VERSION;
  }
}

export const changelogViewed = new ChangelogViewed();
